import React, { useState, useCallback } from 'react';
import { Container } from 'components/UI';
import { Title } from '@landing/ui';
import Item from './Item';
import Certificates from './Certificates';

import * as styles from './Services.module.scss';

export default function Services({ title, subtitle, items, certificates }) {
  const [activeSection, setActiveSection] = useState(null);

  const handleClick = useCallback(
    id => {
      if (activeSection === id) {
        setActiveSection(null);
      } else {
        setActiveSection(id);
      }
    },
    [activeSection],
  );

  return (
    <Container background="gray" theme="stairs">
      <div className={styles.layout}>
        <div className={styles.column}>
          <Title className={styles.title}>{title}</Title>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>
        <div className={styles.column}>
          {items.map(({ title, description }, i) => (
            <Item
              key={title}
              id={i}
              title={title}
              description={description}
              isOpened={activeSection === title}
              onClick={() => handleClick(title)}
            />
          ))}
        </div>
        {certificates && <Certificates certificates={certificates} />}
      </div>
    </Container>
  );
}
